import React, { Component } from 'react';
import PropTypes from 'prop-types';

const chars = '!<>-_\\/[]{}—=+*^?#________';

class TextScramble extends Component {
  constructor(props) {
    super(props);
    this.state = {
      output: ''
    };

    this.update = this.update.bind(this);
    this.setText = this.setText.bind(this);
    this.next = this.next.bind(this);
  }

  componentDidMount() {
    this.queue = [];
    this.frame = 0;
    this.counter = 0;
    this._isMounted = true;
    this.next();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setText(newText) {
    const { maxStart, maxEnd } = this.props;
    const oldText = this.state.output;
    const length = Math.max(oldText.length, newText.length);
    this.queue = [];
    for (let i = 0; i < length; i++) {
      const from = oldText[i] || '';
      const to = newText[i] || '';
      const start = Math.floor(Math.random() * maxStart); // letter start frame
      const end = start + Math.floor(Math.random() * maxEnd); // letter end frame
      this.queue.push({ from, to, start, end });
    }
    cancelAnimationFrame(this.frameRequest);
    this.frame = 0;
    this.update();
  }

  next() {
    if (this._isMounted) {
      const { texts } = this.props;

      this.setText(texts[this.counter]);
    }
  }

  update() {
    let output = '';
    let complete = 0;
    for (let i = 0; i < this.queue.length; i++) {
      let { from, to, start, end, char } = this.queue[i];
      if (this.frame >= end) {
        complete++; // time passed, show actual letter
        output += to;
      } else if (this.frame >= start) {
        if (!char || Math.random() < 0.28) {
          char = this.randomChar(); // letter is changing to random char
          this.queue[i].char = char;
        }
        output += `<span class="dud">${char}</span>`;
      } else {
        output += from; // didn't start yet
      }
    }
    this.setState({ output: output });
    if (complete !== this.queue.length) {
      this.frameRequest = requestAnimationFrame(this.update);
      this.frame++;
    } else {
      const { texts } = this.props;
      if (texts.length > 1) {
        this.counter = (this.counter + 1) % texts.length;
        setTimeout(this.next, 2500);
      }
    }
  }

  randomChar() {
    return chars[Math.floor(Math.random() * chars.length)];
  }

  render() {
    // eslint-disable-next-line react/no-danger
    return <span dangerouslySetInnerHTML={{ __html: this.state.output }} />;
  }
}

TextScramble.defaultProps = {
  maxStart: 40,
  maxEnd: 40
};

TextScramble.propTypes = {
  texts: PropTypes.array.isRequired,
  maxStart: PropTypes.number,
  maxEnd: PropTypes.number
};

export default TextScramble;



// WEBPACK FOOTER //
// ./src/components/TextScramble.js